import { deleteDashPhoneNumber } from './textFormatted';

export function datosContactoFormatted(datos) {
  const efector = datos?.efector?.[0];

  if (!efector) {
    return { datosPrestador: [], datosEmail: [], datosTelefono: [] };
  }

  const datosTelefono = 
    efector?.numerosDeTelefono?.map((telefonoObj) => deleteDashPhoneNumber(telefonoObj?.telefono)) ?? [];
  const datosEmail = 
    efector?.correosElectronicos?.map((mailObj) => mailObj?.mail) ?? [];

  const datosPrestador = [
    ...datosTelefono.map((telefono) => {
      return {
        system: 'phone',
        value: telefono,
        use: 'work',
      };
    }),
    ...datosEmail.map((email) => {
      return {
        system: 'email',
        value: email,
        use: 'work',
      };
    })
  ];

  return { datosPrestador, datosEmail, datosTelefono };
}
